import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Default to Marathi (mr) as primary language
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('shivshri_language');
    return saved || 'mr';
  });

  useEffect(() => {
    localStorage.setItem('shivshri_language', language);
    document.documentElement.lang = language === 'mr' ? 'mr' : 'en';
  }, [language]);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
